import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOAN_APPLICATION_USER_GOTO_START,
} from '../../actions/types'

import {
  loanApplicationUserGotoSuccess,
  loanApplicationUserGotoFailed,
} from '../../actions'

import {
  getLoanApplicationId,
} from '../../reducers'

import { gotoLoanApplicationUser } from '../../requesters/loanApplicationUser'

function* loadApplicationUserGoto(action) {
  const loanApplicationId = yield select(getLoanApplicationId);

  const { response, error } = yield call(gotoLoanApplicationUser, loanApplicationId, action.payload.flow_state)

  if (response) {
    yield put(loanApplicationUserGotoSuccess(response))
  } else {
    yield put(loanApplicationUserGotoFailed(error.response.data.errors))
  }
}

export function* watchLoanApplicationUserGoto() {
  yield takeLatest(LOAN_APPLICATION_USER_GOTO_START, loadApplicationUserGoto);
}
